import { progressiveComponent } from 'site-modules/shared/components/progressive-component/progressive-component';

export const SuggestedVehiclePricingCarouselProgressive = progressiveComponent({
  fullComponent: {
    loader: () =>
      import(
        /* webpackChunkName: "suggested-vehicle-pricing-carousel" */ 'site-modules/shared/components/suggested-vehicle-pricing-carousel/suggested-vehicle-pricing-carousel'
      ),
    name: 'SuggestedVehiclePricingCarousel',
  },
  dataTrackingParent: 'new-footer_pricing_cards',
});
